import { Outlet } from "react-router-dom";
import { useTheme } from "styled-components";

import { ProfilePicture } from "@sso/components/ProfilePicture";
import { ProfileTab } from "@sso/components/ProfileTab";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { ColumnContainer, Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

export const Profile = () => {
  const theme = useTheme();
  const isDownMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const user = useAppSelector(selectCurrentUser);

  return (
    <Flex
      direction={isDownMd ? "column" : "row"}
      bgColor={theme.colors.background.paper}
      rounded
      padding="1rem"
      width="100%"
      justify="flex-start"
      align="flex-start"
    >
      <ColumnContainer minWidth={isDownMd ? "100%" : "300px"} margin="0 0 1rem 0" padding="1rem" justify="flex-start">
        <ProfilePicture />
        <Typography fontWeight="bold" margin="1rem 0" size="1.2rem">
          {user?.username}
        </Typography>
        <Typography>{user?.email}</Typography>
      </ColumnContainer>

      <ColumnContainer
        height="100%"
        flexGrow={1}
        width="100%"
        padding="1rem"
        justify="flex-start"
        position="relative"
        overflow="hidden"
        border={`1px dashed ${theme.colors.secondary.light}`}
        borderRadius="1rem"
      >
        <ProfileTab />
        <Outlet />
      </ColumnContainer>
    </Flex>
  );
};
